
import createIconComponent from './utils/createIconComponent';
import React from 'react';
var IconArrowUpAlt = createIconComponent({ fillContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M12 4.5a2.3 2.3 0 0 1 1.729.78l9.811 11.15a1.847 1.847 0 1 1-2.773 2.439l-8.579-9.75a.25.25 0 0 0-.376 0l-8.579 9.752A1.847 1.847 0 1 1 .46 16.432l9.808-11.148A2.31 2.31 0 0 1 12 4.5z' })
  ), lightContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M.535 18.873a.5.5 0 0 1-.375-.831L11.286 5.469a.998.998 0 0 1 1.498 0L23.91 18.042a.501.501 0 0 1-.374.831.5.5 0 0 1-.374-.168L12.035 6.131.91 18.705a.502.502 0 0 1-.375.168z' })
  ), regularContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M.75 17.939a.752.752 0 0 1-.53-1.281L10.94 5.94c.283-.284.659-.44 1.059-.44.401 0 .777.156 1.06.438l10.721 10.72a.752.752 0 0 1-.53 1.281.743.743 0 0 1-.53-.22L12 7 1.28 17.719a.743.743 0 0 1-.53.22z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconArrowUpAlt.displayName = 'IconArrowUpAlt';
export default IconArrowUpAlt;